import { MonthsEnum } from '@qaroni-core/types/date/months.enum';
import { MaxDayByMonth } from './max-day-by-month';

export class MonthDayInput {
  private static readonly DEFAULT_MAX_DAY = 31;

  public static getMaxDayForMonth(month: MonthsEnum | null): number {
    if (month === null || month === undefined) {
      return this.DEFAULT_MAX_DAY;
    }

    return MaxDayByMonth[month] ?? this.DEFAULT_MAX_DAY;
  }
}
